module.exports = __webpack_public_path__ + "static/media/Project-Production.a75d0634.svg";